import React from "react";

export const AutoScrollToTop = () => {
  React.useEffect(() => {
    document.querySelector(".ebs-layout__container")?.scrollTo(0, 0);
  }, []);
  return <></>;
};
